// extracted by mini-css-extract-plugin
export default {"button":"MenuItem_button__fP7S2","button--wm":"MenuItem_button--wm__FQy1M","button--dm":"MenuItem_button--dm__7C7OM","button--ripple":"MenuItem_button--ripple__im2ft"};